var ɵ0 = function (moment) {
    return function (input) {
        return moment(input).format("MMM DD, YYYY");
    };
};
var filter = ['moment', ɵ0];
export var FourDotFiveDateFormat = {
    name: 'fourdotfiveDateFormat',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-date-format.filter.js.map